"use strict";
/**
 * 错误码常量
 * -----------------------------------------------------------------------------
 * **完整清单与含义见 docs/04-contracts/错误码表.md。**
 * 新增错误码须同步该文档与 docs/04-contracts/openapi.yaml。
 *
 * 此处只登记代码中需要按码分支处理的部分；其余以字符串常量形式使用。
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_HTTP_STATUS = exports.ERROR_MESSAGE_SUGGESTION = exports.ERROR_MESSAGE_FALLBACK = exports.ErrorCode = void 0;
exports.apiOk = apiOk;
exports.apiError = apiError;
exports.ErrorCode = {
    // ---- 认证与会话 ----
    AUTH_SESSION_MISSING: 'AUTH-001',
    AUTH_SESSION_EXPIRED: 'AUTH-002',
    AUTH_CODE_INVALID: 'AUTH-003',
    AUTH_CODE_EXPIRED: 'AUTH-004',
    AUTH_MP_UNAVAILABLE: 'AUTH-005',
    AUTH_NOT_FOLLOWED: 'AUTH-006',
    AUTH_BAD_CREDENTIALS: 'AUTH-007',
    AUTH_ACCOUNT_DISABLED: 'AUTH-008',
    AUTH_TOO_MANY_ATTEMPTS: 'AUTH-009',
    AUTH_FORWARDED_LINK: 'AUTH-010',
    /** 账号处于「首次登录 / 密码被重置」状态，必须先改密才能调用其他后台接口 */
    AUTH_INITIAL_PASSWORD_CHANGE: 'AUTH-011',
    // ---- 授权 ----
    AUTHZ_FORBIDDEN: 'AUTHZ-001',
    AUTHZ_FIELD_FORBIDDEN: 'AUTHZ-002',
    AUTHZ_CROSS_USER: 'AUTHZ-003',
    AUTHZ_CONFIRM_REQUIRED: 'AUTHZ-004',
    /** 不能对当前登录账号自身执行该操作（停用自己 / 重置自己密码等） */
    AUTHZ_SELF_OPERATION: 'AUTHZ-005',
    /** 违反账号安全约束：会使系统失去最后一个可用管理员，或移除自己的全部角色 */
    AUTHZ_ACCOUNT_SAFETY: 'AUTHZ-006',
    /** 系统预置角色（isSystem）不可删除 */
    AUTHZ_SYSTEM_ROLE: 'AUTHZ-007',
    // ---- 状态机 ----
    STATE_ILLEGAL_TRANSITION: 'STATE-001',
    STATE_CONFLICT: 'STATE-002',
    STATE_TERMINAL: 'STATE-003',
    STATE_PRECONDITION_FAILED: 'STATE-004',
    // ---- 报名 ----
    ENROLL_DUPLICATE: 'ENROLL-001',
    ENROLL_BATCH_CLOSED: 'ENROLL-002',
    ENROLL_TYPE_DISABLED: 'ENROLL-003',
    ENROLL_FORM_INVALID: 'ENROLL-004',
    ENROLL_SCHEMA_MISSING: 'ENROLL-005',
    ENROLL_NOT_FOUND: 'ENROLL-006',
    ENROLL_FIELD_LOCKED: 'ENROLL-007',
    ENROLL_FIELD_NEEDS_REVIEW: 'ENROLL-008',
    ENROLL_IDEMPOTENT_REPEAT: 'ENROLL-009',
    ENROLL_TOO_FREQUENT: 'ENROLL-010',
    /** 金额不一致（Σ 分项 − 减免额 ≠ 总价）或减免额非法 —— 见 docs/04-contracts/错误码表.md */
    ENROLL_PRICE_MISMATCH: 'ENROLL-011',
    // ---- 身份核验（硬失败，详见核验文档 §3）----
    KYC_OCR_UNAVAILABLE: 'KYC-001',
    KYC_OCR_NO_CARD: 'KYC-002',
    KYC_OCR_LOW_CONFIDENCE: 'KYC-003',
    /** 核验影像上传格式不受支持（JPG / PNG 之外）—— 与 STORAGE-001 的区别：此码面向核验页面的用户提示 */
    KYC_FILE_TYPE: 'KYC-004',
    /** 核验影像超出体积上限 */
    KYC_FILE_SIZE: 'KYC-005',
    /** 证件疑似被 PS / 编辑篡改（百度 card_ps=1 或返回编辑软件名）—— 硬失败，要求用原件重拍 */
    KYC_OCR_EDITED: 'KYC-006',
    /** 证件非原件（复印件 / 扫描件 / 翻拍屏摄 / 截屏 / 临时身份证）—— 硬失败，要求用原件重拍 */
    KYC_OCR_NOT_ORIGINAL: 'KYC-007',
    /**
     * 国徽面位置放的是**人像面**（百度 `image_status=reversed_side`）。
     *
     * 单独立码而不是复用 `KYC-002`：「没识别到身份证」会让学员去调光线重拍同一面，
     * 而实际动作是**把证件翻过来** —— 两种提示对应的动作完全不同。
     */
    KYC_OCR_WRONG_SIDE: 'KYC-008',
    KYC_ID_CHECKSUM: 'KYC-101',
    KYC_ID_REGION: 'KYC-102',
    KYC_ID_BIRTHDAY: 'KYC-103',
    KYC_ID_FORMAT: 'KYC-104',
    KYC_ID_AGE: 'KYC-105',
    KYC_ID_EXPIRED: 'KYC-106',
    KYC_FACE_UNAVAILABLE: 'KYC-201',
    KYC_FACE_NOT_DETECTED: 'KYC-202',
    KYC_FACE_LOW_SIMILARITY: 'KYC-203',
    KYC_PHOTO_NOT_CAMERA: 'KYC-301',
    KYC_PHOTO_QUALITY: 'KYC-302',
    KYC_PHOTO_TOO_MANY_RETRY: 'KYC-303',
    /**
     * 人像分割（换底）服务不可用。
     *
     * 单独立码而不是复用 `KYC-201`（头像比对不可用）：那是**另一个供应商产品**，
     * 凭据、权限、计费各自独立，运维排查时要能一眼分清是哪条通道挂了。
     */
    KYC_SEG_UNAVAILABLE: 'KYC-304',
    KYC_STEP_ORDER: 'KYC-401',
    KYC_STEP_PREREQUISITE: 'KYC-402',
    /** 准入通过线未达标 → **不允许提交**（核验是提交前门槛，不是提交后审核）—— 见 06-身份核验.md */
    KYC_ADMISSION_FAILED: 'KYC-501',
    // ---- 缴费与匹配 ----
    PAY_FILE_TYPE: 'PAY-001',
    PAY_FILE_PARSE: 'PAY-002',
    PAY_FILE_EMPTY: 'PAY-003',
    PAY_ALL_DUPLICATED: 'PAY-004',
    PAY_TXN_NOT_FOUND: 'PAY-005',
    PAY_STATUS_NOT_ALLOWED: 'PAY-006',
    PAY_AMOUNT_MISMATCH: 'PAY-007',
    PAY_ALREADY_RECONCILED: 'PAY-008',
    PAY_REG_ALREADY_RECONCILED: 'PAY-009',
    PAY_REVOKE_REASON_REQUIRED: 'PAY-010',
    PAY_INFO_MISSING: 'PAY-011',
    PAY_CODE_CONFLICT: 'PAY-012',
    PAY_IMPORT_IN_PROGRESS: 'PAY-013',
    // ---- 退费 ----
    REFUND_NOT_FOUND: 'REFUND-001',
    REFUND_DUPLICATE: 'REFUND-002',
    REFUND_STATUS_NOT_ALLOWED: 'REFUND-003',
    REFUND_FIELDS_INCOMPLETE: 'REFUND-004',
    // ---- 物流 ----
    LOGISTICS_STATUS_NOT_ALLOWED: 'LOGISTICS-001',
    LOGISTICS_ADDRESS_INCOMPLETE: 'LOGISTICS-002',
    LOGISTICS_TRACKING_INVALID: 'LOGISTICS-003',
    LOGISTICS_TRACKING_DUPLICATE: 'LOGISTICS-004',
    LOGISTICS_NOT_FOUND: 'LOGISTICS-005',
    LOGISTICS_SHIPPED_CANNOT_EDIT: 'LOGISTICS-006',
    LOGISTICS_PICKUP_EXISTS: 'LOGISTICS-007',
    /** 领取方式非「现场领取」，不可登记领取台账 */
    LOGISTICS_PICKUP_METHOD_REQUIRED: 'LOGISTICS-008',
    /** 领取方式为「现场领取」，不可登记发货 */
    LOGISTICS_SHIP_METHOD_REQUIRED: 'LOGISTICS-009',
    // ---- 通知 ----
    NOTIFY_SMS_UNAVAILABLE: 'NOTIFY-001',
    NOTIFY_TEMPLATE_MISSING: 'NOTIFY-002',
    NOTIFY_SIGN_MISMATCH: 'NOTIFY-003',
    NOTIFY_DEDUP_SKIPPED: 'NOTIFY-004',
    NOTIFY_MP_NOT_AUTHORIZED: 'NOTIFY-005',
    NOTIFY_EVENT_UNKNOWN: 'NOTIFY-006',
    NOTIFY_RATE_LIMITED: 'NOTIFY-007',
    // ---- 手机号短信验证（附件1「手机号真实性验证」，2026-10-16 补实现）----
    /** 发送过频：同号 60s 冷却窗口内重复请求 */
    PHONE_SEND_TOO_FREQUENT: 'PHONE-001',
    /** 验证码错误 / 已过期 / 尝试次数超限 */
    PHONE_CODE_INVALID: 'PHONE-002',
    /** 当日发送量达上限（同号 10 条 / 天，防轰炸） */
    PHONE_SEND_LIMIT_DAILY: 'PHONE-003',
    /** 号码格式非法（仅放行大陆手机号 1[3-9] 开头 11 位） */
    PHONE_FORMAT_INVALID: 'PHONE-004',
    /** 提交报名：表单手机号未经短信验证（ENROLL 链的验证门槛） */
    PHONE_NOT_VERIFIED: 'PHONE-005',
    /** 图形验证码错误 / 已过期 / 已消费（发码前的人机校验，2026-10-27 补） */
    PHONE_CAPTCHA_INVALID: 'PHONE-006',
    /** 同账号（openid）/ 同号的请求过频（发码 / 取图形码超限，2026-10-27 补） */
    PHONE_USER_LIMIT: 'PHONE-007',
    // ---- 账号级资料（2026-10-31）----
    /** 账号姓名不合法：去首尾空白后为空，或长度不在 2~20 */
    PROFILE_NAME_INVALID: 'PROFILE-001',
    /** 账号尚无手机号，提交时又未带 `phone` + `code`（手机号是资料完成的必要条件） */
    PROFILE_PHONE_REQUIRED: 'PROFILE-002',
    // ---- 表单与配置 ----
    FORM_FIELD_INVALID: 'FORM-001',
    FORM_VISIBLE_WHEN_INVALID: 'FORM-002',
    FORM_PUBLISHED_IMMUTABLE: 'FORM-003',
    FORM_PUBLISHED_UNDELETABLE: 'FORM-004',
    FORM_DUPLICATE_KEY: 'FORM-005',
    FORM_SYSTEM_FIELD: 'FORM-006',
    FORM_PRICE_EXCLUSIVE: 'FORM-007',
    CONFIG_NOT_FOUND: 'CONFIG-001',
    CONFIG_VALUE_TYPE_MISMATCH: 'CONFIG-002',
    CONFIG_THRESHOLD_OUT_OF_RANGE: 'CONFIG-003',
    /** 编码已存在（code 唯一冲突）—— 见 docs/04-contracts/错误码表.md §11 */
    CONFIG_CODE_CONFLICT: 'CONFIG-004',
    // ---- 存储与资产 ----
    STORAGE_TYPE_NOT_ALLOWED: 'STORAGE-001',
    STORAGE_TOO_LARGE: 'STORAGE-002',
    STORAGE_NOT_FOUND: 'STORAGE-003',
    STORAGE_SIGNATURE_EXPIRED: 'STORAGE-004',
    STORAGE_UNAVAILABLE: 'STORAGE-005',
    STORAGE_DELETE_FAILED: 'STORAGE-006',
    ASSET_NOT_FOUND: 'ASSET-001',
    // ---- 开票（单表生命周期：REQUESTED → ISSUED / REJECTED，见口径 C-25） ----
    /** 单位抬头缺纳税人识别号 */
    INVOICE_TAX_NO_REQUIRED: 'INVOICE-001',
    /** 该报名单已有未驳回的申请（同一报名单只开一张票） */
    INVOICE_ALREADY_ISSUED: 'INVOICE-002',
    /** 报名单状态不允许申请开票（未进入 `ENROLLED` 及之后） */
    INVOICE_STATE_NOT_ALLOWED: 'INVOICE-003',
    /** 开票金额超过实缴金额 */
    INVOICE_AMOUNT_EXCEEDED: 'INVOICE-004',
    /** 申请已被处理（已开具 / 已驳回），不可重复处理 —— 仅后台动作会命中 */
    INVOICE_REQUEST_HANDLED: 'INVOICE-005',
    /**
     * 导入名单无法作为可读表格打开（格式不支持 / 空文件 / 结构损坏 / 超出单次上限）。
     * `details.reason` 给具体原因 —— 财务手里的文件是导出的还是自己另存的，
     * 只有他能从这句读出来该怎么修。
     */
    INVOICE_IMPORT_FILE_UNREADABLE: 'INVOICE-006',
    /** 导入名单缺少必需列（`details.missing` 列出列名）。整批拒绝，不猜列 */
    INVOICE_IMPORT_HEADER_INVALID: 'INVOICE-007',
    // ---- 客服码（C-10：按区域匹配 + 全局缺省，图片自维护） ----
    SUPPORT_REGION_INVALID: 'SUPPORT-001',
    SUPPORT_REGION_CONFLICT: 'SUPPORT-002',
    SUPPORT_ASSET_PURPOSE: 'SUPPORT-003',
    /** 学员端未匹配到任何可用客服码（含缺省码未配置 / 停用 / 图片缺失） */
    SUPPORT_QRCODE_UNAVAILABLE: 'SUPPORT-004',
    // ---- 系统 ----
    SYS_VALIDATION: 'SYS-001',
    SYS_NOT_FOUND: 'SYS-002',
    SYS_RATE_LIMITED: 'SYS-003',
    SYS_INTERNAL: 'SYS-004',
    SYS_DB: 'SYS-005',
    SYS_CRON_FAILED: 'SYS-006',
    SYS_ENV_MISSING: 'SYS-007',
    SYS_NOT_IMPLEMENTED: 'SYS-008',
    /** 后台账号用户名已存在 */
    SYS_USERNAME_CONFLICT: 'SYS-009',
    /** 角色编码已存在 */
    SYS_ROLE_CODE_CONFLICT: 'SYS-010',
    /** 角色仍被账号引用，不能删除 */
    SYS_ROLE_IN_USE: 'SYS-011',
    /** 口令不符合复杂度要求（长度 / 字符组合 / 与用户名相同） */
    SYS_PASSWORD_POLICY: 'SYS-012',
    // ---- 对外 MCP 接入（口径 C-26）----
    /** 未携带凭据，或 `Authorization` 不是 `Bearer mcp_…` 形态 */
    MCP_TOKEN_MISSING: 'MCP-001',
    /** 凭据不存在 / 已吊销 / 已过期 / 归属账号已停用 —— 对外统一说法，不区分原因（防枚举） */
    MCP_TOKEN_INVALID: 'MCP-002',
    /** 作用域不足（READ 调写工具）或账号缺少该工具所需权限码 */
    MCP_SCOPE_FORBIDDEN: 'MCP-003',
    /** 该账号未吊销的令牌已达上限 */
    MCP_TOKEN_LIMIT: 'MCP-004',
    /** 调用频率超限（每 Token 每分钟） */
    MCP_RATE_LIMITED: 'MCP-005',
    /** JSON-RPC 方法或工具名不存在 */
    MCP_METHOD_NOT_FOUND: 'MCP-006',
    /** 工具入参不符合 `inputSchema` */
    MCP_INVALID_ARGUMENTS: 'MCP-007',
    /** 同一账号下 Agent 名称重复 */
    MCP_TOKEN_NAME_CONFLICT: 'MCP-008',
    /** 令牌已吊销，不能重复吊销 */
    MCP_TOKEN_ALREADY_REVOKED: 'MCP-009',
    /** MCP 接入总开关已关闭 */
    MCP_DISABLED: 'MCP-010',
};
/** 面向用户的可理解提示（服务端返回 message 时的兜底文案；不暴露内部细节） */
exports.ERROR_MESSAGE_FALLBACK = {
    'SYS-004': '系统繁忙，请稍后重试',
    'SYS-005': '系统繁忙，请稍后重试',
    'SYS-007': '系统配置异常，请联系管理员',
};
/**
 * 错误码 → 用户提示文案。
 * -----------------------------------------------------------------------------
 * 逐条抄自 `docs/04-contracts/错误码表.md` 的「用户提示建议」列。
 * 服务端不传 message 时由 `DomainException` 取这里的文案 ——
 * 目的是让提示语只有一个来源，避免各接口各写一版（同一错误三种说法，用户会困惑）。
 */
exports.ERROR_MESSAGE_SUGGESTION = {
    'AUTH-001': '请从公众号菜单重新进入',
    'AUTH-002': '登录状态已过期，请重新进入',
    'AUTH-003': '授权失败，请重新进入',
    'AUTH-004': '授权超时，请重新进入',
    'AUTH-005': '微信服务暂时不可用，请稍后重试',
    'AUTH-006': '请先关注公众号后再使用',
    'AUTH-007': '账号或密码错误',
    'AUTH-008': '账号已停用，请联系管理员',
    'AUTH-009': '尝试次数过多，请稍后再试',
    'AUTH-010': '请从公众号菜单进入',
    'AUTH-011': '请先修改初始密码后再使用',
    'AUTHZ-001': '您没有权限执行此操作',
    'AUTHZ-002': '您没有权限查看该信息',
    'AUTHZ-003': '无权访问该数据',
    'AUTHZ-004': '请完成身份确认后重试',
    'AUTHZ-005': '不能对当前登录账号执行此操作',
    'AUTHZ-006': '该操作会使系统失去可用管理员，已阻止',
    'AUTHZ-007': '系统预置角色不允许删除',
    'STORAGE-001': '文件类型不支持',
    'STORAGE-002': '文件过大，请压缩后重试',
    'STORAGE-003': '文件不存在或已过期',
    'STORAGE-004': '链接已过期，请刷新后重试',
    'STORAGE-005': '存储服务暂时不可用，请稍后重试',
    'STORAGE-006': '文件删除失败，请稍后重试',
    'CONFIG-001': '配置项不存在',
    'CONFIG-002': '配置值不合法',
    'CONFIG-003': '配置值超出合理范围',
    'CONFIG-004': '该编码已被使用，请更换后保存',
    'SUPPORT-001': '区域不合法，或缺省码与区域不能同时设置',
    'SUPPORT-002': '该区域（或全局缺省）已存在客服码',
    'SUPPORT-003': '二维码图片不符合要求，请重新上传',
    'SUPPORT-004': '暂无可用客服码，请稍后再试或联系工作人员',
    // 开票：4 个码此前只在错误码表里存在、没有面向用户的措辞（本批补实现时一并补齐）
    'INVOICE-001': '开单位发票需要填写纳税人识别号，请补充后提交',
    'INVOICE-002': '该报名单的发票已申请或已开具，无需重复提交',
    'INVOICE-003': '当前报名状态暂不能申请发票，请完费后再试',
    'INVOICE-004': '开票金额不能超过实缴金额',
    'INVOICE-005': '该申请已处理，请刷新后查看',
    'INVOICE-006': '这份名单打不开，请用「导出待开票」得到的文件并保持 xlsx 格式',
    'INVOICE-007': '名单缺少必需列（报名单号 / 发票号码），请勿删改表头后再导入',
    'KYC-006': '证件照片疑似被编辑或篡改，请使用证件原件重新拍摄',
    'KYC-007': '请使用身份证原件拍摄，不支持复印件、扫描件、翻拍屏摄或截屏',
    'KYC-008': '这是身份证的人像面，请翻到国徽面后再拍',
    'KYC-501': '核验未达标，请按提示重拍后重新提交',
    'KYC-304': '证件照生成服务暂时不可用，请稍后重试',
    'SYS-001': '请求参数有误，请检查后重试',
    'SYS-002': '数据不存在或已被删除',
    'SYS-003': '操作过于频繁，请稍后再试',
    'SYS-004': '系统繁忙，请稍后重试',
    'SYS-005': '系统繁忙，请稍后重试',
    'SYS-006': '系统繁忙，请稍后重试',
    'SYS-007': '系统配置异常，请联系管理员',
    'SYS-008': '该功能暂未开放',
    'SYS-009': '该用户名已被使用，请更换后重试',
    'SYS-010': '该角色编码已被使用，请更换后重试',
    'SYS-011': '该角色仍被账号使用，请先调整相关账号后再删除',
    'SYS-012': '密码不符合安全要求，请按提示重新设置',
    'PROFILE-001': '姓名请填写 2 到 20 个字',
    'PROFILE-002': '请先填写并验证手机号',
    'MCP-001': '缺少接入凭据，请在请求头携带 Bearer 令牌',
    'MCP-002': '接入凭据无效或已失效，请重新签发',
    'MCP-003': '该凭据无权执行此操作，请检查作用域或联系管理员授权',
    'MCP-004': '该账号的接入凭据数量已达上限，请先吊销不用的凭据',
    'MCP-005': '调用过于频繁，请稍后重试',
    'MCP-006': '不支持的方法或工具名',
    'MCP-007': '参数不符合要求，请检查后重试',
    'MCP-008': '该 Agent 名称已被使用，请更换后重试',
    'MCP-009': '该凭据已吊销，无需重复操作',
    'MCP-010': '对外接入能力当前未开启',
    'PAY-001': '仅支持 CSV / Excel 文件',
    'PAY-002': '文件缺少必需列，请使用指定模板',
    'PAY-003': '文件中没有可导入的数据',
    'PAY-004': '该文件已导入过，无新增数据',
    'PAY-005': '流水记录不存在',
    'PAY-006': '该报名单当前不可核销',
    'PAY-007': '金额与应付不一致，需人工确认',
    'PAY-008': '该流水已核销，请勿重复操作',
    'PAY-009': '该报名单已核销',
    'PAY-010': '请填写撤销原因',
    'PAY-011': '收款信息异常，请联系客服',
    'PAY-012': '系统繁忙，请稍后重试',
    'PAY-013': '上一次导入尚未完成，请稍后',
    'NOTIFY-001': '短信服务暂时不可用',
    'NOTIFY-002': '短信模板配置异常',
    'NOTIFY-003': '短信签名配置异常',
    'NOTIFY-004': '（不展示给用户）',
    'NOTIFY-005': '（走降级，不展示）',
    'NOTIFY-006': '系统配置异常',
    'NOTIFY-007': '操作过于频繁',
    'PHONE-001': '发送过于频繁，请稍后再试',
    'PHONE-002': '验证码错误或已过期',
    'PHONE-003': '今日验证码发送次数已达上限',
    'PHONE-004': '手机号格式不正确',
    'PHONE-005': '请先完成手机号短信验证后再提交',
    'PHONE-006': '图形验证码错误或已过期，请重新输入',
    'PHONE-007': '操作过于频繁，请稍后再试',
};
/**
 * 错误码 → HTTP 状态码。
 * -----------------------------------------------------------------------------
 * 与 `docs/04-contracts/错误码表.md` 的 HTTP 列**全量对齐**（134/134）：
 * 此前只登记一部分，未登记的码在 `DomainException` 里静默回落 400，
 * 让契约写 409 / 503 的码（并发冲突、服务不可用）被前端按「用户错误」处理
 * 而不重试 —— 评审（2026-10-23）确认 `STATE-002` / `ENROLL-008` 两处实际偏差
 * 即源于此。覆盖完整性由 `pnpm contract:check` 第 8 项机器校验。
 */
exports.ERROR_HTTP_STATUS = {
    'AUTH-001': 401,
    'AUTH-002': 401,
    'AUTH-003': 401,
    'AUTH-004': 401,
    'AUTH-005': 503,
    'AUTH-006': 403,
    'AUTH-007': 401,
    'AUTH-008': 403,
    'AUTH-009': 429,
    'AUTH-010': 403,
    'AUTH-011': 403,
    'AUTHZ-001': 403,
    'AUTHZ-002': 403,
    'AUTHZ-003': 403,
    'AUTHZ-004': 403,
    'AUTHZ-005': 403,
    'AUTHZ-006': 403,
    'AUTHZ-007': 403,
    // ---- 状态机（契约：冲突类一律 409） --------------------------------------
    'STATE-001': 409,
    'STATE-002': 409,
    'STATE-003': 409,
    'STATE-004': 409,
    // ---- 报名 ----------------------------------------------------------------
    'ENROLL-001': 409,
    'ENROLL-002': 400,
    'ENROLL-003': 400,
    'ENROLL-004': 400,
    'ENROLL-005': 500,
    'ENROLL-006': 404,
    'ENROLL-007': 403,
    'ENROLL-008': 409,
    'ENROLL-009': 409,
    'ENROLL-010': 429,
    'ENROLL-011': 400,
    // ---- 身份核验（服务不可用 503；顺序/前置 409；通过线 422） ----------------
    'KYC-001': 503,
    'KYC-002': 400,
    'KYC-003': 400,
    'KYC-004': 400,
    'KYC-005': 400,
    'KYC-101': 400,
    'KYC-102': 400,
    'KYC-103': 400,
    'KYC-104': 400,
    'KYC-105': 400,
    'KYC-106': 400,
    'KYC-201': 503,
    'KYC-202': 400,
    'KYC-203': 400,
    'KYC-301': 403,
    'KYC-302': 400,
    'KYC-303': 429,
    'KYC-401': 409,
    'KYC-402': 409,
    // ---- 退费 ----------------------------------------------------------------
    'REFUND-001': 404,
    'REFUND-002': 409,
    'REFUND-003': 409,
    'REFUND-004': 400,
    // ---- 物流 ----------------------------------------------------------------
    'LOGISTICS-001': 409,
    'LOGISTICS-002': 400,
    'LOGISTICS-003': 400,
    'LOGISTICS-004': 409,
    'LOGISTICS-005': 404,
    'LOGISTICS-006': 409,
    'LOGISTICS-007': 409,
    'LOGISTICS-008': 400,
    'LOGISTICS-009': 400,
    // ---- 表单 / 资产 ----------------------------------------------------------
    'FORM-001': 400,
    'FORM-002': 400,
    'FORM-003': 409,
    'FORM-004': 409,
    'FORM-005': 400,
    'FORM-006': 400,
    'FORM-007': 400,
    'ASSET-001': 404,
    'STORAGE-001': 400,
    'STORAGE-002': 400,
    'STORAGE-003': 404,
    'STORAGE-004': 403,
    'STORAGE-005': 503,
    'STORAGE-006': 500,
    'CONFIG-001': 404,
    'CONFIG-002': 400,
    'CONFIG-003': 400,
    'CONFIG-004': 409,
    'SUPPORT-001': 400,
    'SUPPORT-002': 409,
    'SUPPORT-003': 400,
    'SUPPORT-004': 404,
    'INVOICE-001': 400,
    'INVOICE-002': 409,
    'INVOICE-003': 409,
    'INVOICE-004': 400,
    'INVOICE-005': 409,
    'INVOICE-006': 400,
    'INVOICE-007': 400,
    'KYC-006': 400,
    'KYC-007': 400,
    'KYC-008': 400,
    'KYC-501': 422,
    'KYC-304': 503,
    'SYS-001': 400,
    'SYS-002': 404,
    'SYS-003': 429,
    'SYS-004': 500,
    'SYS-005': 500,
    'SYS-006': 500,
    'SYS-007': 500,
    'SYS-008': 501,
    'SYS-009': 409,
    'SYS-010': 409,
    'SYS-011': 409,
    'SYS-012': 400,
    'PROFILE-001': 400,
    'PROFILE-002': 400,
    // ---- 对外 MCP 接入（C-26）。MCP-006 是「工具/方法不存在」，按资源不存在给 404
    'MCP-001': 401,
    'MCP-002': 401,
    'MCP-003': 403,
    'MCP-004': 409,
    'MCP-005': 429,
    // 006 / 007 是「请求内容本身不合法」（方法名 / 工具名 / 入参）。
    // 在 JSON-RPC 层它们表现为 `-32601` / `-32602`（HTTP 仍 200）；
    // 若冒泡到 HTTP 层，用 400 比 404 更准确 —— 不是资源不存在，是这次请求写错了。
    'MCP-006': 400,
    'MCP-007': 400,
    'MCP-008': 409,
    'MCP-009': 409,
    'MCP-010': 503,
    'PAY-001': 400,
    'PAY-002': 400,
    'PAY-003': 400,
    'PAY-004': 409,
    'PAY-005': 404,
    'PAY-006': 409,
    'PAY-007': 409,
    'PAY-008': 409,
    'PAY-009': 409,
    'PAY-010': 400,
    'PAY-011': 500,
    'PAY-012': 500,
    'PAY-013': 409,
    'NOTIFY-001': 503,
    'NOTIFY-002': 500,
    'NOTIFY-003': 500,
    // 004 / 005 是「已按预期处理」的旁路结果，不是失败：HTTP 200，文案不面向用户
    'NOTIFY-004': 200,
    'NOTIFY-005': 200,
    'NOTIFY-006': 500,
    'NOTIFY-007': 429,
    'PHONE-001': 429,
    'PHONE-002': 400,
    'PHONE-003': 429,
    'PHONE-004': 400,
    'PHONE-005': 422,
    'PHONE-006': 400,
    'PHONE-007': 429,
};
/**
 * 构造成功响应包络。
 * 三端共用同一形状，避免前端为每个接口写一套解包逻辑。
 */
function apiOk(data, traceId) {
    return traceId === undefined ? { success: true, data } : { success: true, data, traceId };
}
/**
 * 构造失败响应包络。
 */
function apiError(code, message, extra) {
    return {
        success: false,
        code,
        message,
        ...(extra?.traceId === undefined ? {} : { traceId: extra.traceId }),
        ...(extra?.details === undefined ? {} : { details: extra.details }),
    };
}
//# sourceMappingURL=errors.js.map